<template>
  <v-list-item
    class="pt-0 pb-3 px-0 history-item"
    :class="{'answer flex-row-reverse': has_answer}">
    <v-list-item-avatar
      v-if="item.user || avatar"
      class="align-self-start my-0">
      <UserIcon
        v-if="item.user || avatar"
        class="avatar"
        :name="item.user ? item.user.fullName || item.user.name : avatar "
        size="30"
        :src="item.user ? item.user.avatar : null"/>
    </v-list-item-avatar>
    <v-list-item-content
      class="py-0 align-self-start"
      :class="!item.user && !avatar ? has_answer ? 'mr-6' : 'ml-2' : has_answer ? 'ml-9 mr-2' : 'mr-9 ml-2' ">
      <v-list-item-title>
        <PersonTooltip
          v-if="item.user || item.userId"
          :avatar=" item.user && item.user.avatar ? item.user.avatar : '' "
          :department="item.user && item.user.department ? item.user.department : {} "
          :item="item.user"
          :name="item.user ? item.user.fullName || item.user.name : item.userId"/>
        <div
          class="pr-2 h7-text"
          :class="{'text-right': has_answer}">
          {{ title }}
        </div>
        <div
          class="h8-text grey--text"
          :class="{'text-right': has_answer}">
          {{ modified ? $t('Common.Modified') :'' }}
          {{ item_time | formatDate }}
        </div>
      </v-list-item-title>
      <v-hover
        v-if="content"
        v-slot="{ hover }">
        <v-sheet class="pa-4 text-left mt-1 main__green">
          <v-row
            v-if="commented"
            class="px-4 pb-2 flex-nowrap"
            no-gutters>
            <sDivider
              class="mr-1"
              color="var(--black-color)"
              vertical/>
            <span class="h8-text">{{ commented }}</span>
          </v-row>
          <div class="h7-text">
            {{ content }}
          </div>
          <v-btn
            v-if="hover && answer"
            class="h9-text px-1 mt-1"
            small
            text
            @click="$emit('toComment', item)">
            {{ $t(`Common.${commented ? 'Change' : 'Answer'}`) }}
          </v-btn>
        </v-sheet>
      </v-hover>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'

import { i18n } from 'plugins/i18n.js'

export default {
  name: 'historyItem',
  props: {
    item: Object,
    title: String,
    avatar: String,
    item_time: String,
    content: String,
    commented: String,
    answer: Boolean,
    modified: Boolean
  },
  filters: {
    formatDate(value) {
      if (value) {
        return `${i18n.d(new Date(value), 'shortDate')}, ${i18n.d(new Date(value), 'time')}`
        //return moment(value).format('DD.MM.YYYY, HH:mm')
      }
    },
  },
  computed: {
    has_answer() {
      return this.answer && this.item.answer
    }
  },
  components: {
    UserIcon,
    PersonTooltip
  }
}
</script>
<style lang="scss" scoped>
.history-item {
  .v-sheet {
    border-radius: 0 20px 20px 20px;
  }
  &.answer {
    .v-sheet {
      border-radius:20px 0  20px 20px;
    }
  }
}
.name {
  font-weight: 500;
}
.avatar {
  max-width: 100%;
  max-height: 100%;
}
.v-list-item__avatar {
  margin-right: 4px !important;
}
</style>
<style lang="scss">
.history-item {
  .v-list-item__avatar {
    width: 30px !important;
    min-width: 30px !important;
    height: 30px !important;
  }
}
</style>
